import React, { useEffect, useRef } from "react";
import {
  SofturaTable,
  Tooltip,
  Datepicker
} from "../../../../../CommonComponents";
import customerMyOrderDetails from "../../../../../../redux/CustomerMyOrder/operations";
import "./PendingOrderGrid.scss";
import Moment from "moment";
import { useDispatch } from "react-redux";
import comment from "../../../../../assets/images/Comments.png";
import { GetStatusIcon } from "client/utils/IconsUtil";
import { CONSTANTS } from "client/utils/constants";
import GridFiltersAction from "Store/Component/GridDataFilters/GridDataFiltersAction"
import { FilteringMode } from 'ka-table/enums';
import { HOME_ACTIVE_MENU } from "../../../../../utils/constants/homeGridConstants"
import { formatPrice } from "utils";
import { CustomTextFilterDiv, commonFilterDropDown } from "client/utils/RequisitionUtil";

const PendingOrderGrid = (props: any) => {
  const {
    myOrdersGridFilters,
    pendingApprovalGridFilters,
    allPendingApprovalGridFilters,
    fleetProcessingGridFilters,
    orderDate,
    updateDate,
    selectStatus,
    selectRegion,
    selectRequsetType,
    selectPreAuthorizationFlag,
    selectCostCenter,
    selectUpdatedBy,
    selectAssignedTo,
    selectRequestedBy,
    selectItemStatus,
    selectDispositionType,
    serverTotal,
    pagesCount,
    dispositionTypeList,
    setSelectedDispositionKey,
    isGridDataLoading = true,
    isDropDownsLoading = true,
    setSelectedBuyerNameKey,
    buyerNameList,
    selectBuyerName,
    setOrderPriceFilter,
    orderPriceFilterRef
  } = props
  const ordersStatus: any = useRef(props?.ordersStatus);
  const orderRequestType: any = useRef(props?.orderRequestType);
  const updatedByList: any = useRef(props?.updatedByList);
  const assignedToList: any = useRef(props?.assignedToList);
  const requestedByList: any = useRef(props?.requestedByList)
  const regionList = useRef<any>(props?.regionList);
  const costCenterList = useRef<any>(props?.costCenterList);
  const itemStatus = useRef<any>(props?.itemStatusOptions);
  const dispositionType = useRef<any>(props?.dispositionTypeList)
  const buyerName = useRef<any>(buyerNameList)

  const [data, setData] = React.useState(props?.Data);

  const dispatch = useDispatch();

  useEffect(() => {
    setData(props?.Data);
  }, [JSON.stringify(props?.Data)]);

  useEffect(() => {
    if (props?.ordersStatus !== ordersStatus?.current) {
      ordersStatus.current = props?.ordersStatus;
    }
    if (props?.orderRequestType !== orderRequestType?.current) {
      orderRequestType.current = props?.orderRequestType;
    }
    if (props?.updatedByList !== updatedByList?.current) {
      updatedByList.current = props?.updatedByList
    }
    if (props?.assignedToList !== assignedToList?.current) {
      assignedToList.current = props?.assignedToList
    }
    if (props?.requestedByList !== requestedByList?.current) {
      requestedByList.current = props?.requestedByList
    }
    if (props?.regionList !== regionList?.current) {
      regionList.current = props?.regionList
    }
    if (props?.costCenterList !== costCenterList?.current) {
      costCenterList.current = props?.costCenterList
    }
    if (props?.itemStatusOptions !== itemStatus?.current) {
      itemStatus.current = props?.itemStatusOptions
    }
    if (props?.dispositionType !== dispositionType?.current) {
      dispositionType.current = props?.dispositionTypeList
    }
    if (props?.buyerName != buyerName?.current) {
      buyerName.current = props?.buyerNameList
    }
  }, [props?.BranchList, props?.ordersStatus, props.orderRequestType, props?.updatedByList, props?.assignedToList, props?.requestedByList, props?.itemStatusOptions, props?.dispositionTypeList, props?.regionList, props?.costCenterList, props?.allApprovalRequestType, props?.buyerNameList]);

  const iconReturn = (status: any) => {
    const icon = GetStatusIcon(status)?.icon;
    let classNameTemp = "";
    if (status === CONSTANTS.ORDER_STATUS.FLEET_PROCESSING || status === CONSTANTS.ORDER_STATUS.PROCESSING) {
      classNameTemp = 'fleetprocessingicon statusIcon';
    } else {
      classNameTemp = 'statusIcon'
    }
    return <img src={icon} alt="statusIcon" className={classNameTemp} />;
  };

  const handleOrderClearSelectFilter = (search: any, value: any, column: any) => {
    if (column?.key === 'costCenter') {
      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ costCenter: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ costCenter: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ costCenter: '' }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ costCenter: '' }))
      }
    }

    if (column?.key === 'regionName') {
      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ regionName: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ regionName: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ regionName: '' }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ regionName: '' }))
      }
    }

    if (column.key === 'status') {
      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ status: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ status: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ status: '' }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ status: '' }))
      }
    }
    if (column.key === 'orderRequestType') {
      if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ orderRequestType: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ orderRequestType: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ orderRequestType: '' }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ orderRequestType: '' }))
      }
    }
    if (column.key === 'updatedBy') {
      if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ updatedBy: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ updatedBy: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ updatedBy: '' }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ updatedBy: '' }))
      }
    }
    if (column.key === 'assignedTo') {
      if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ assignedTo: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ assignedTo: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ assignedTo: '' }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ assignedTo: '' }))
      }
    }
    if (column.key === 'requestedBy') {
      if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction?.setHomePendingApprovalGridFilters({ requestedBy: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ requestedBy: '' }))
      } else if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ requestedBy: '' }))
      } else {
        dispatch(GridFiltersAction?.setHomeMyOrdersGridFilters({ requestedBy: '' }))
      }
    }
    if (column.key === 'fleetItemStatus') {
      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ fleetItemStatus: '' }))
      }
    }
    if (column.key === 'dispositionType') {
      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ dispositionType: '' }))
      }
    }
    if (column.key === 'buyerName') {
      if (props?.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction?.setHomeFleetProcessingGridFilters({ buyerName: '' }))
      }
    }
    if (column.key === 'isApprovalOverride') {
      if (props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction?.setHomeAllPendingApprovalGridFilters({ isApprovalOverride: 'All' }))
      }
    }
    search(undefined);
    value.current = "";
  };

  const CustomFilterCell = (props: any) => {
    const { column, search, options } = props;
    const myOrderHandleChange = (event: any, columnName: any) => {
      if (event?.label !== CONSTANTS.SELECT) {
        if (columnName === "costCenter") {
          selectCostCenter.current = event?.label;
          search(event?.label);
        } else if (columnName === "status") {
          selectStatus.current = event?.label;
          search(event?.label);
        } else if (columnName === 'regionName') {
          selectRegion.current = event?.label
          search(event?.label);
        } else if (columnName === "updatedBy") {
          selectUpdatedBy.current = event?.label
          search(event?.label);
        } else if (columnName === "assignedTo") {
          selectAssignedTo.current = event?.label
          search(event?.label)
        } else if (columnName === "requestedBy") {
          selectRequestedBy.current = event?.label
          search(event?.label)
        } else if (columnName === "fleetItemStatus") {
          selectItemStatus.current = event?.label
          search(event?.label)
        } else if(columnName === "dispositionType") {
          setSelectedDispositionKey(event?.value)
          selectDispositionType.current = event?.label
          search(event?.label)
        } else if (columnName === "buyerName") {
          setSelectedBuyerNameKey(event?.value)
          selectBuyerName.current = event?.label
          search(event?.label)
        } else if(columnName === "isApprovalOverride"){
          dispatch(GridFiltersAction.setHomeAllPendingApprovalGridFilters({isApprovalOverride: event?.label} ))
          selectPreAuthorizationFlag.current = event?.label
        } else {
          selectRequsetType.current = event?.label;
          search(event?.label);
        }
      } else {
        if (columnName === "regionName") {
          selectRegion.current = event?.label
        } else if (columnName === "updatedBy") {
          selectUpdatedBy.current = event?.label;
        } else if (columnName === "assignedTo") {
          selectAssignedTo.current = event?.label;
        } else if (columnName === "requestedBy") {
          selectRequestedBy.current = event?.label;
        } else if (columnName === "costCenter") {
          selectCostCenter.current = event?.label;
        } else if (columnName === "status") {
          selectStatus.current = event?.label;
        } else if (columnName === "fleetItemStatus") {
          selectItemStatus.current = event?.label
        } else if (columnName === "dispositionType") {
          selectDispositionType.current = event?.value
        } else if(columnName === "buyerName"){
          selectBuyerName.current = event?.value
        } else if(columnName === "isApprovalOverride"){
          selectPreAuthorizationFlag.current = event?.label
        } else {
          selectRequsetType.current = event?.label;
        }
        search();
      }
    };

    const getValue = () => {
      if (column?.key === "costCenter") {
        return selectCostCenter
      } else if (column?.key === "status") {
        return selectStatus
      } else if (column?.key === "regionName") {
        return selectRegion
      } else if (column?.key === "updatedBy") {
        return selectUpdatedBy
      } else if (column?.key === "requestedBy") {
        return selectRequestedBy
      } else if (column?.key === "assignedTo") {
        return selectAssignedTo
      } else if (column?.key === "fleetItemStatus") {
        return selectItemStatus
      } else if (column?.key === "dispositionType") {
        return selectDispositionType
      } else if(column?.key === "buyerName"){
        return selectBuyerName
      } else if (column?.key === "isApprovalOverride") {
        if (selectPreAuthorizationFlag.current == "") {
          selectPreAuthorizationFlag.current = "All"
        }
        return selectPreAuthorizationFlag
      } else {
        return selectRequsetType
      }
    }

    let filterDropDown = commonFilterDropDown(props?.onClickValue, getValue, column, myOrderHandleChange, options, handleOrderClearSelectFilter, search)
    return filterDropDown
  };

  const handlePODateFilter = (date: any, search: any, setDate: any) => {
    search(Moment(date).format("MM/DD/YYYY"));
    setDate.current = date;
  };

  const handlePOClearDateFilter = (search: any, setDate: any, column: any) => {
    if (column?.key === 'orderDate') {
      if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction.setHomePendingApprovalGridFilters({ orderDate: '' }))
      } else if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters({ orderDate: '' }))
      } else if (props.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction.setHomeAllPendingApprovalGridFilters({ orderDate: '' }))
      } else {
        dispatch(GridFiltersAction.setHomeMyOrdersGridFilters({ orderDate: '' }))
      }
    } else {
      if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction.setHomePendingApprovalGridFilters({ updatedDate: '' }))
      } else if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters({ updatedDate: '' }))
      }  else if (props.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction.setHomeAllPendingApprovalGridFilters({ updatedDate: '' }))
      } else {
        dispatch(GridFiltersAction.setHomeMyOrdersGridFilters({ updatedDate: '' }))
      }
    }
    search(undefined);
    setDate.current = undefined;
  };

  const OrderPODateFilterCell = (orderDateData: any) => {
    const { search, column } = orderDateData;
    return (
      <div className="date-filter-wrapper">
        <Datepicker
          placeholder={CONSTANTS.SELECT}
          value={orderDate.current}
          onChangeDate={(date: any) =>
            handlePODateFilter(date, search, orderDate)
          }
          allowTextInput={false}
         data-attribute="PendingOrderGrid_Default_Datepicker" />
        <i
          className="fa fa-times-circle-o"
          aria-hidden="true"
          onClick={() => handlePOClearDateFilter(search, orderDate, column)}
        ></i>
      </div>
    );
  };
  const UpdatePODateFilterCell = (updateDateData: any) => {
    const { search, column } = updateDateData;
    return (
      <div className="date-filter-wrapper">
        <Datepicker
          placeholder={CONSTANTS.SELECT}
          value={updateDate.current}
          onChangeDate={(date: any) =>
            handlePODateFilter(date, search, updateDate)
          }
         data-attribute="PendingOrderGrid_Default_Datepicker_2" />
        <i
          className="fa fa-times-circle-o"
          aria-hidden="true"
          onClick={() => handlePOClearDateFilter(search, updateDate, column)}
        ></i>
      </div>
    );
  };

  const activeRow = customerMyOrderDetails.dispatchRowData(dispatch);
  const activeRowData = (item: any) => {
    return activeRow(item);
  };

  const getFilteredValue = (columnName: any) => {
    if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      return pendingApprovalGridFilters[columnName];
    } else if (props.activeMenu === HOME_ACTIVE_MENU.MY_ORDERS) {
      return myOrdersGridFilters[columnName];
    } else if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      return fleetProcessingGridFilters[columnName]
    } else if(props?.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL){
      return allPendingApprovalGridFilters[columnName]
    }
  }

  const orderPriceFilterOnchange = (e: any) => {
    setOrderPriceFilter(e.target.value)
    orderPriceFilterRef.current = e.target.value
    if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
      dispatch(GridFiltersAction.setHomePendingApprovalGridFilters({ orderPrice: e.target.value }))
    } else if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
      dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters({ orderPrice: e.target.value }))
    } else if (props.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
      dispatch(GridFiltersAction.setHomeAllPendingApprovalGridFilters({ orderPrice: e.target.value }))
    } else {
      dispatch(GridFiltersAction.setHomeMyOrdersGridFilters({ orderPrice: e.target.value }))
    }
  }

  const ApproverColumns = [
    {
      key: "orderId",
      title: "LEADR Order #",
      Cell: (row: any) => {
        return (
          <a
            href="/"
            onClick={(e: any) => {
              props?.onOrderIdClicked(e, row);
              activeRowData(row);
            }}
            className="order-link-id"
          >
            {row.rowData.status === "Unsubmitted"
              ? "Draft"
              : row.rowData.orderId}
          </a>
        );
      },
      width: 60,
      filterRowValue: getFilteredValue('orderId') ?? ''
    },
    {
      key: "status",
      title: "Status",
      Cell: (row: any) => {
        return (
          <a
            href="/"
            onClick={(e: any) => {
              props?.onOrderIdClicked(e, row);
              activeRowData(row);
            }}
            className="status"
          > {iconReturn(row.rowData.status)} <span className={`${row.rowData.status == 'Fleet Processing' ? 'status-text fleetprocessing' : 'status-text'}`}>{row.rowData.status}</span></a>
        );
      },
      width: 140,
      FilterCell: (statusProps: any) => {
        return <CustomFilterCell {...statusProps} dataItem={data} options={ordersStatus?.current} />;
      },
      filterRowValue: getFilteredValue('status') ?? ''
    },
    {
      key: "orderDate",
      title: "Order Date",
      FilterCell: (orderDateProps: any) => {
        return <OrderPODateFilterCell {...orderDateProps} dataItem={data} />;
      },
      width: 130,
      filterRowValue: getFilteredValue('orderDate') ?? ''
    },
    {
      key: "regionName",
      title: "Region",
      width: 160,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={data}
          options={regionList.current}
        />
      ),
      filterRowValue: getFilteredValue('regionName') ?? ''
    },
    {
      key: "costCenter",
      title: "Cost Center",
      width: 160,
      FilterCell: (props: any) => (
        <CustomFilterCell
          {...props}
          dataItem={data}
          options={costCenterList.current}
        />
      ),
      filterRowValue: getFilteredValue('costCenter') ?? ''
    },
    {
      key: "orderRequestType",
      title: "Request Type",
      width: 140,
      Cell: (typeRow: any) => {
        const requesttype = typeRow.rowData.orderRequestType?.toString();
        return (
          <p>{requesttype?.replaceAll(",", " | ")}</p>);
      },
      FilterCell: (props: any) => {
        return <CustomFilterCell {...props} dataItem={data} options={orderRequestType.current} />;
      },
      filterRowValue: getFilteredValue('orderRequestType') ?? ''
    },
    {
      key: "quantity",
      title: "Qty",
      width: 60,
      filterRowValue: getFilteredValue('quantity') ?? ''
    },
    {
      key: "requestedBy",
      title: "Created By",
      width: 120,
      FilterCell: (statusProps: any) => {
        return <CustomFilterCell {...statusProps} dataItem={data} options={requestedByList.current} />;
      },
      filterRowValue: getFilteredValue('requestedBy') ?? ''
    },
    {
      key: "updatedDate",
      title: "Updated Date",
      width: 120,
      FilterCell: (updatedDateProps: any) => {
        return <UpdatePODateFilterCell {...updatedDateProps} dataItem={data} />;
      },
      filterRowValue: getFilteredValue('updatedDate') ?? ''
    },
    {
      key: "updatedBy",
      title: "Updated By",
      width: 120,
      FilterCell: (statusProps: any) => {
        return <CustomFilterCell {...statusProps} dataItem={data} options={updatedByList.current} />;
      },
      filterRowValue: getFilteredValue('updatedBy') ?? ''
    },
    {
      key: "assignedTo",
      title: "Assigned To",
      width: 120,
      FilterCell: (statusProps: any) => {
        return <CustomFilterCell {...statusProps} dataItem={data} options={assignedToList.current} />;
      },
      filterRowValue: getFilteredValue('assignedTo') ?? ''
    },

    {
      key: "orderPrice",
      title: "Order Price ($)",
    
      Cell: (orderPriceRow: any) => {
        return (
          <span className="orderPriceCell">
            {" "}
            {orderPriceRow.rowData.orderPrice != null ? (
              <p>{'$ ' + formatPrice(orderPriceRow.rowData.orderPrice || 0, 2) || '-'}</p>
            ) : (
              ""
            )}
          </span>
        );
      },
      width: 90,
      FilterCell: () => {
        return <div className="orderpriceCell"><CustomTextFilterDiv orderPriceFilter = {orderPriceFilterRef.current} onChange = {(e: any) => {orderPriceFilterOnchange(e)} } /></div>;
      }
    },
    {
      key: "comment",
      title: "Comments",
      width: 80,
      Cell: (commentsRow: any) => {
        const temp_comment = commentsRow.rowData.comments.map((cmt: any) => { return cmt.comment }).join(" ");
        commentsRow.rowData['comment'] = temp_comment;
        const commentsContent = commentsRow.rowData.approverComments;
        const commentsTooltipProps: any = {
          onRenderContent: () => {
            if (typeof commentsContent === "string") {
              return <div>{commentsContent}</div>;
            } else if (Array.isArray(commentsContent)) {
              return (
                <div className="tooltipConversation">
                  {commentsContent.map((item: any, index: number) => {
                    return (
                      <>
                        <div
                          className={`chat ${item.type === "reply" ? "reply" : "message"
                            }`}
                          key={index}
                        >
                          <p className="author">{item.author}</p>
                          <div className="comment">
                            <p>
                              <span className="blueText">OrderId &nbsp;</span>
                              {commentsRow.rowData.orderId}
                            </p>
                            <p className="comment_area">{item.comment}</p>
                          </div>
                        </div>
                        <br />
                      </>
                    );
                  })}
                </div>
              );
            }
          },
        };
        return commentsRow.rowData.approverComments?.length > 0 ? (
          <Tooltip tooltipProps={commentsTooltipProps} data-attribute="PendingOrderGrid_Default_Tooltip">
            <div className="commentBlock">
              <img src={comment} alt="comment" className="comments" />
            </div>
          </Tooltip>
        ) : null;
      },
    },
  ];

  const [approverColumns, setApproverColumns] = React.useState(ApproverColumns);

  const itemStatusColumn = {
    key: "fleetItemStatus",
    title: "Item Status",
    Cell: (row: any) => {
      return row?.rowData?.fleetItemDetail?.map((item: any) => {
        return <React.Fragment key={item?.itemNumber || item?.itemStatus}>
          <p>{item?.itemNumber ? `${item?.itemNumber} - ${item?.itemStatus}` : item?.itemStatus}</p>
        </React.Fragment>
      })
    },
    width: 140,
    FilterCell: (props: any) => {
      return (
        <CustomFilterCell
          {...props}
          dataItem={data}
          options={itemStatus.current}
        />
      )
    },
    filterRowValue: getFilteredValue('fleetItemStatus') ?? ''
  }

  const preAuthorizedfilterOption = [
    { label: "All", value: "All", key: "All" },
    { label: "Yes", value: "Yes", key: "Yes" },
    { label: "No", value: "No", key: "No" }]

  const preAuthorizedFlagColumn = {
    key: "isApprovalOverride",
    title: "Pre Authorized",
    width: 140,
    Cell: (typeRow: any) => {
      let val = "No"
      if (typeRow.rowData.isApprovalOverride) {
        val = "Yes"
      }
      return (
        <p>{val}</p>);
    },
    FilterCell: (props: any) => {
      return (
        <CustomFilterCell
          {...props}
          dataItem={data}
          options={preAuthorizedfilterOption}
        />
      )
    },
    filterRowValue: ''
  }

  const dispositionTypeColumn = {
    key: "dispositionType",
    title: "Disposition Type",
    Cell: (row: any) => {
      return row?.rowData?.orderDispositionType?.map((item: any) => {
        return <p>{item} </p>
      })
    },
    width: 140,
    FilterCell: (props: any) => {
      return (
        <CustomFilterCell
          {...props}
          dataItem={data}
          options={dispositionTypeList}
        />
      )
    },
    filterRowValue: getFilteredValue('dispositionType') ?? ''
  }

  const buyerNameColumn = {
    key: "buyerName",
    title: "Buyer Name",

    width: 140,
    FilterCell: (props: any) => {
      return (
        <CustomFilterCell
          {...props}
          dataItem={data}
          options={buyerNameList}
        />
      )
    },
    filterRowValue: getFilteredValue('buyerName') ?? ''
  }

  useEffect(() => {
    if (props?.activeMenu === HOME_ACTIVE_MENU?.PENDING_FLEET_PROCESSING) {
      ApproverColumns.splice(2, 0, itemStatusColumn)
      ApproverColumns.splice(3, 0, dispositionTypeColumn)
      approverColumns.splice(9, 0, buyerNameColumn)
      let fleetColumns = ApproverColumns.filter((column: any) => !["quantity", "assignedTo", "frsOrderNumber"].includes(column?.key))

      setApproverColumns(fleetColumns)
    }else if(props?.activeMenu == HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL){
      ApproverColumns.splice(6, 0, preAuthorizedFlagColumn)
      setApproverColumns(ApproverColumns)
    } else {
      setApproverColumns(ApproverColumns);
    }
  }, [JSON.stringify(data), props?.activeMenu]);

  const setFilters = (value: any) => {
    if (JSON.stringify(value) !== '{}') {
      if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_APPROVALS_ORDER) {
        dispatch(GridFiltersAction.setHomePendingApprovalGridFilters(value))
      } else if (props.activeMenu === HOME_ACTIVE_MENU.PENDING_FLEET_PROCESSING) {
        dispatch(GridFiltersAction.setHomeFleetProcessingGridFilters(value))
      }  else if (props.activeMenu === HOME_ACTIVE_MENU.ALL_PENDING_APPROVAL) {
        dispatch(GridFiltersAction.setHomeAllPendingApprovalGridFilters(value))
      } else {
        dispatch(GridFiltersAction.setHomeMyOrdersGridFilters(value))
      }
    }
  }

const returGridHeaderClassName = (status: any) => {
  let src = "";
  switch (status) {
      case HOME_ACTIVE_MENU?.PENDING_APPROVALS_ORDER:
      case HOME_ACTIVE_MENU?.ALL_PENDING_APPROVAL:
          src = 'pendingapprovals';
          break;
      case HOME_ACTIVE_MENU?.MY_ORDERS:
        src = 'myorders';
        break;
      case HOME_ACTIVE_MENU?.PENDING_FLEET_PROCESSING:
          src = 'fleetprocessing';
          break;
      default:
          break;
  }
  return src;
}

  return (
    <div
      className={`order-listing-grid ${data?.length != 0 ? "softura-table" : "softura-table paginationNav"
        } ${returGridHeaderClassName(props?.activeMenu)}`}
    >
      {!props.showGrid &&
        <SofturaTable
          key={props?.gridKey}
          data={props?.Data ?? []}
          columns={approverColumns}
          sort={true}
          defaultPageSize={10}
          pageSizes={[10, 20, 50]}
          globalSearch={false}
          filter={true}
          className={`order-listing-grid`}
          filteringMode={FilteringMode.FilterRow}
          getFilterValue={setFilters}
          serverTotal={serverTotal}
          fetchAction={props?.fetchAction}
          isServerSide={true}
          pagesCount={pagesCount}
          defaultPaginationPosition='Both'
          fixedHeader={true}
          loading={(isGridDataLoading || isDropDownsLoading)}
         data-attribute="PendingOrderGrid_Default_Grid" />
      }
    </div>
  );
};

export default PendingOrderGrid;